import React from "react";
import {Row, Container, Col, Form, Button, Modal, Table } from "react-bootstrap";


export default function DeleteOrgModal(props) {
  return (
    <Modal className="delete-org-modal" show={props.showDeleteModal} onHide={() => props.setShowDeleteModal(false)} style={{ textAlign: "center" }}>
      <div className="page-1">
        <Modal.Header closeButton>
          {" "}
          <Row className="mb-2 justify-content-center" style={{ margin: "auto" }}>
            <Col>
              <h4 className="text-danger">Are you sure you want to delete?</h4>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <Row className=" mb-5">
            <Col>
              <p className="f16 text-danger">
                WARNING!
              </p>
              <p className="f16">
                Be absolutely sure that this is what you are intending to do. If you delete this organization, every client company within this org will be deleted as well. There is no way to restore this data once it is deleted.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center pb-2">
            <Col className="name-input">
              <Form className="create-new-org">
                <Row style={{ marginBottom: "30px" }} className="justify-content-center mt-2">
                  <Col>
                    <p className="text-bold f16">
                      If you are absolutely sure you want to proceed, type '<span className="font-weight-bold">{ props.deleteTarget.name }</span>' below and click delete.
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Control 
                      className="lite-input"
                      defaultValue="" 
                      style={{ width: "591px", maxWidth: "100%", margin: "0 auto 40px auto" }} 
                      required 
                      onChange={(e) => {
                        props.setDeleteLocked(e.target.value != props.deleteTarget.name)
                      }} 
                    />
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  <Col className="fbl">
                    <button
                      type="button"
                      className="button b-type-primary b-size-small btn-code"
                      onClick={() => props.setShowDeleteModal(false)}
                    >
                      Cancel
                    </button>
                    </Col>
                    <Col className="fbr">
                    <button
                      disabled={props.deleteLocked}
                      className="org-mgmt-btn btn btn-danger btn-sm"
                      onClick={() => props.deleteOrg(props.deleteTarget)}
                    >
                      Delete { props.deleteTarget.name }
                    </button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </div>
    </Modal>
  )
}